"use client"

import Image from "next/image"
import Link from "next/link"

const StoreButtons = ({ ...props }) => {
  return props.theme.light ? (
    <div className="flex flex-row mt-4 text-sm font-lealti-light text-gray-600">
      <Link
        href="https://apps.apple.com/us/app/lealti/id6757312584"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          src="/appstore-button.png"
          alt="Icono flecha derecha"
          width={185}
          height={50}
          className="object-cover w-[185px] px-4 h-auto mr-2  rounded-xl border bg-white border-gray-200"
        />
      </Link>
      <Link href="#" target="_blank" rel="noopener noreferrer">
        <Image
          src="/googleplay-button.png"
          alt="Icono flecha derecha"
          width={185}
          height={50}
          className="object-cover w-[185px] px-4 h-auto mr-2  rounded-xl border bg-white border-gray-200 "
        />
      </Link>
    </div>
  ) : (
    <div className="flex flex-row mt-4 text-sm font-lealti-light text-gray-600">
      <a
        href="https://apps.apple.com/us/app/lealti/id6757312584"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          src="/appstore-button.png"
          alt="Icono flecha derecha"
          width={185}
          height={50}
          className="object-cover w-[185px] px-4 h-auto mr-2  rounded-xl bg-white"
        />
      </a>
      <a href="#" target="_blank" rel="noopener noreferrer">
        <Image
          src="/googleplay-button.png"
          alt="Icono flecha derecha"
          width={185}
          height={50}
          className="object-cover w-[185px] px-4 h-auto mr-2  rounded-xl bg-white"
        />
      </a>
    </div>
  )
}
export default StoreButtons
